import type { ApiClient } from "./client";
import type { SystemInfoResponse } from "./types";

const BASE = "/api/v1/system";

export function createSystemService(client: ApiClient) {
  return {
    getInfo: () => client.fetch<SystemInfoResponse>(`${BASE}/info`),
  };
}

export type SystemService = ReturnType<typeof createSystemService>;
